/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom} from 'rxjs';
import {Inject, Injectable} from '@angular/core';
import * as _ from 'lodash';

import {ObjectTypeFinder} from '../../app/common/constants/object-type';
import {UserProfileApiService} from '../../app/admin/user-profile/user-profile-api.service';
import {LocalNetworkProfile} from './local-network-profile';
import {LocalUserProfile} from './local-user-profile';

@Injectable({
  providedIn: 'root'
})
export class UserProfileSaverService {
  constructor(
    // Factory product — duck-typed resource API (save/get/...).
    @Inject(UserProfileApiService) private readonly UserProfile: UserProfileApiService,
    private readonly localUserProfile: LocalUserProfile,
    private readonly LocalNetworkProfile: LocalNetworkProfile,
  ) {
  }

  saveObj(obj: any, profileKeyPrefix: string, objType?: any): void {
    if (!obj.url) {
      return;
    }

    const oType = objType || ObjectTypeFinder.findObjectFromUrl(obj.url);
    if (!(obj.id && obj.name && oType)) {
      return;
    }

    const networkId = this.LocalNetworkProfile.getNetworkId();
    const app = this.localUserProfile.getCurrentApp();
    const profileKey = profileKeyPrefix + networkId + (app === 'ADVERTISING' ? '' : app);
    let localUser = this.localUserProfile.get();
    let profile = localUser.profile;

    profile[profileKey] = _.isArray(profile[profileKey]) ? profile[profileKey] : [];
    profile[profileKey].unshift({
      id: obj.id,
      objectType: oType.type,
      name: obj.name
    });
    profile[profileKey] = _.uniqBy(profile[profileKey], 'id');
    profile[profileKey] = _.slice(profile[profileKey], 0, 10);

    this.localUserProfile.publish(profileKey, profile[profileKey]);

    firstValueFrom(this.UserProfile.saveProfile({
      id: localUser.userId,
      profile: _.pick(profile, [profileKey])
    })).then((apiUser: any) => {
      localUser = this.localUserProfile.safeSaveProfile(profileKey, apiUser.profile[profileKey]);
      profile = localUser.profile;
    });
  }
}
